import React, { useEffect } from "react";

/**
 * Development-only logger
 */

const PaymentTable = ({ payments }) => {

 /**
 * Log when component mounts or payments change
 */
 useEffect(() => {



 if (!payments) {

 return;
 }

 if (!Array.isArray(payments)) {

 return;
 }



 if (payments.length > 0) { 

 } else {



 }

 }, [payments]);


 /**
 * Render log
 */



 /**
 * Safety fallback
 */
 if (!payments || payments.length === 0) {



 return (
 <div className="no-payments">
 No payments found
 </div>
 );

 }


 return (

 <table className="payments-table">

 <thead>
 <tr>
 <th>User Id</th>
 <th>User</th>
 <th>Email</th>
 <th>Plan ID</th>
 <th>Plan</th>
 <th>Amount</th>
 <th>Status</th>
 <th>Order ID</th>
 <th>Date</th>
 </tr>
 </thead>

 <tbody>

 {payments.map((payment) => {



 return (

 <tr key={payment.id}>

 <td>
 {payment.userId || "N/A"}
 </td>


 <td>
 {payment.userName || "N/A"}
 </td>

 <td>
 {payment.userEmail || "N/A"}
 </td>

 <td>
 {payment.planId || "N/A"}
 </td>

 <td>
 {payment.planName || "N/A"}
 </td>

 <td>
 ₹{(payment.amount/ 100) || 0}
 </td>

 <td>

 <span
 className={`status ${
 payment.status === "SUCCESS"
 ? "active"
 : "inactive"
 }`}
 >
 {payment.status || "UNKNOWN"}
 </span>

 </td>

 <td>
 {payment.razorpayOrderId || "N/A"}
 </td>

 <td>

 {payment.createdAt
 ? new Date(payment.createdAt).toLocaleString()
 : "N/A"}

 </td>

 </tr>

 );

 })}

 </tbody>

 </table>

 );

};

export default PaymentTable;
